// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel_panel__rBpE1","panelDesktop":"panel_panelDesktop__NAnr0","small":"panel_small__M3mh2"};